import React from 'react';
import { motion } from 'framer-motion';
const PAIN_POINTS = [{
  emoji: '😤',
  text: 'Comprás packs de planificaciones que cuando los abrís son genéricos, hechos con IA mediocre y no sirven para tus alumnos reales.'
}, {
  emoji: '⏰',
  text: 'Pasás horas del domingo planificando cuando podrías estar con tu familia o simplemente descansando.'
}, {
  emoji: '💸',
  text: 'Gastás en PDFs de "especialistas" que son copias de ChatGPT mal hecho, vendidos a precio de oro.'
}, {
  emoji: '😰',
  text: 'Querés usar IA pero no sabés exactamente cómo pedirle lo que necesitás sin recibir basura genérica.'
}, {
  emoji: '📚',
  text: 'Reutilizás planificaciones viejas porque no tenés tiempo de crear material nuevo adaptado a tus alumnos.'
}, {
  emoji: '🔄',
  text: 'El ciclo no para: buscás, comprás, te decepcionás, repetís. Es agotador y costoso.'
}];
export function PainSection() {
  return <section className="py-12 bg-zinc-950" data-id="element-239">
      <div className="max-w-4xl mx-auto px-4" data-id="element-240">
        <div className="text-center mb-8" data-id="element-241">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl md:text-4xl font-black uppercase tracking-tight text-white mb-3" data-id="element-242">
            ¿Te Suena Familiar?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-base md:text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-243">
            Sos docente. Trabajás más que nadie. Y el domingo sigue siendo tuyo
            solo de nombre.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-10" data-id="element-244">
          {PAIN_POINTS.map((point, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-zinc-900 border-l-4 border-red-500 rounded-r-lg p-4 shadow-lg" data-id="element-245">
              <div className="flex items-start gap-3" data-id="element-246">
                <span className="text-2xl flex-shrink-0" data-id="element-247">{point.emoji}</span>
                <p className="text-sm text-gray-300 leading-relaxed" data-id="element-248">
                  {point.text}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-yellow-500/10 border-l-4 border-yellow-500 p-6 md:p-8 rounded-r-xl text-center max-w-3xl mx-auto" data-id="element-249">
          <p className="text-lg md:text-xl text-yellow-500 font-medium italic leading-relaxed" data-id="element-250">
            "El problema no sos vos. Es que nadie te enseñó a usar la IA
            correctamente para tu trabajo real."
          </p>
        </motion.div>
      </div>
    </section>;
}